import defaultVariant from './default';
import apps from './apps';
import analyze from './analyze';
import billing from './billing';
import developer from './developer';
import mrx from './mrx';
export * from './types';
export var VARIANTS = {
  analyze: analyze,
  apps: apps,
  billing: billing,
  default: defaultVariant,
  developer: developer,
  mrx: mrx
};
//# sourceMappingURL=index.js.map